import createAction from 'redux-actions/es/createAction';

import { FETCH_GIFT_SET } from './consts/types';

export { findGiftSetByById } from '@esentai/core/features/giftSets/actions';

export const fetchGiftSet = createAction(FETCH_GIFT_SET);
